import { configureStore } from "@reduxjs/toolkit";

import templatesReducer from "./slices/templateSlice";
import desktopsReducer from "./slices/desktopSlice";
import keycloakReducer from "./slices/keycloakSlice";
import userReducer from "./slices/userSlice";
import systemReducer from "./slices/systemSlice";
import imageReducer from "./slices/imageSlice";
import { environment } from "./config.js";

// import {
//   persistStore,
//   persistReducer,
//   FLUSH,
//   REHYDRATE,
//   PAUSE,
//   PERSIST,
//   PURGE,
//   REGISTER,
//   } from 'redux-persist';

const isEnvNoAuth = environment === "production-no-auth";
const userReducerUsed = isEnvNoAuth ? userReducer : keycloakReducer;

const store = configureStore({
  reducer: {
    template: templatesReducer,
    desktop: desktopsReducer,
    user: userReducerUsed,
    system: systemReducer,
    image: imageReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }), // find a long term solution for this
  //   middleware: (getDefaultMiddleware) =>
  //     getDefaultMiddleware({
  //       serializableCheck: {
  //     ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
  //   },
  // }),
});

export default store;
